import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { CardDTOBase } from "./CardDTOBase";
import type { PersonStaff } from "./PersonStaff";
import type { PurchasableState } from "./PurchasableState";
import type { TrackedBase } from "./TrackedBase";

export class CardStaff implements CardDTOBase, TrackedBase {
  constructor(public readonly assignId: number, public readonly personId: PersonStaff | null, public readonly issueDate: Date | null, public readonly cardNum: string, public readonly temp: boolean, public readonly active: boolean | null, public readonly paid: string | null, public readonly price: number | null, public readonly purchaseDate: Date | null, public readonly purchasableState: PurchasableState, public readonly voidCloseId: number | null, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null) {
    this.cbiServiceContext = null;
    this.personIdLoaded = this.personId != null;
    this.personIdCached = this.personId;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private personIdLoaded: boolean;
  private personIdCached: PersonStaff | null;
  async personIdLazy(): Promise<PersonStaff | null> {
    if (!this.personIdLoaded) {
      this.personIdCached = await this.cbiServiceContext!.cardService().getCardStaffPersonId(this.assignId);
      this.personIdLoaded = true;
    }
    return this.personIdCached;
  }
}
